module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "tocheading"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "img_container2"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Image",
      "src": "images/img1.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Author"
    }
  }, [_vm._v("Author’s Biography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One: ")]), _vm._v("A Brief History of Folkestone and the Outbreak of War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Two: ")]), _vm._v("1914 – Starting Out")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three: ")]), _vm._v("1915 – Deepening Conflict")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Four: ")]), _vm._v("1916 – The Realisation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Five: ")]), _vm._v("1917 – Seeing it through")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Six: ")]), _vm._v("1918 – The Final Push")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Seven: ")]), _vm._v("Folkestone War Memorial")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Eight: ")]), _vm._v("Folkestone Voluntary Aid Detachment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Nine: ")]), _vm._v("Women in the War")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Ten: ")]), _vm._v("The aftermath of the war")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0